"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickModuleEditorSaveSchema = void 0;
const baseSchema_1 = require("../baseSchema");
const baseClickSchema_1 = require("../baseSchema/baseClickSchema");
class ClickModuleEditorSaveSchema extends baseClickSchema_1.BaseClickSchema {
    constructor({ path, productId }) {
        super({ componentName: 'FreeModuleModalSaveButton' });
        this.action = baseSchema_1.ActionsName.CLICK_CREATE_MODULE;
        this.path = path;
        this.productId = productId || 0;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            pathUrl: this.path,
            productId: this.productId
        };
    }
}
exports.ClickModuleEditorSaveSchema = ClickModuleEditorSaveSchema;
